import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Erp Sanbox
export const BRAND_NAME = "ProfessioNail Operation"; // App Name
export const SANDBOX = false;
export const VERSION = "v0.1.23";
const firebaseConfig = {
  apiKey: "AIzaSyDvL-M22wlNpzVEH_iNvfMpcXBPkA2DQCw",
  authDomain: "professionail.firebaseapp.com",
  projectId: "professionail",
  storageBucket: "professionail.appspot.com",
  messagingSenderId: "321432185577",
  appId: "1:321432185577:web:32ad94cd385ca6e8191e78",
  measurementId: "G-XGH32JVGTB",
};

firebase.initializeApp(firebaseConfig);

export default firebase;

export const authApp = firebase.initializeApp(firebaseConfig, "authApp");

// ========================= App String ========================= //
export const MAP_API_KEY = "AIzaSyCu_IMhYlj7IuVoC2w_m9d2OR_BfYqMazw"; // Google map API
export const MAX_INPUT = 8; // Tối đa số lượt input in out
export const URL = {
  // url
  home: "/",
  signin: "/signin",
  branch: "/branch",
  roster: "/roster",
  request: "/request",
  reportManagement: "/report",
  reportTimeTracking: "/report_time_tracking",
};
